export const SUPPORTED_LANGUAGES = ["fr_FR", "en_US"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = "en_US";
